import React from 'react';
import {diseasedZones} from "../../../../../util/varibles/constants";
import DiseasedZone from "./DiseasedZone";

interface IProps {
    showControl?: boolean
}

const DiseasedZones: React.FC<IProps> = ({showControl = true}) => {

    const content = diseasedZones.map((item) => <DiseasedZone
        key={item.id}
        data={item}
        showControl={showControl}
    />);

    return showControl ? <div className='flex flex-col'>{content}</div> : <>{content}</>;
};

export default DiseasedZones;
